// The productions in the order they were last opened (Home's Continue), kept per browser. Pure apart from the
// storage helpers.
import { safeGet, safeSet } from "../auth.ts";

const KEY = "filmsquare.recent";
const FOLDED_KEY = "filmsquare.sideFolded";

/** The ids in a stored JSON list; anything that is not a list of strings reads as nothing. */
export function parseIds(raw: string | null): string[] {
  try {
    const v = JSON.parse(raw ?? "[]");
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export const loadRecent = (): string[] => parseIds(safeGet(KEY));

/** Put a production first; keeps the ten most recent. */
export function pushRecent(list: readonly string[], id: string): string[] {
  return [id, ...list.filter((x) => x !== id)].slice(0, 10);
}

export const saveRecent = (list: readonly string[]) => safeSet(KEY, JSON.stringify(list));

/** The `n` most recent of the productions there are; productions never opened follow in list order. */
export function orderRecent<T extends { id: string }>(
  projects: readonly T[],
  recent: readonly string[],
  n = 3,
): T[] {
  const rank = (p: T) => {
    const i = recent.indexOf(p.id);
    return i < 0 ? recent.length + projects.indexOf(p) : i;
  };
  return [...projects].sort((a, b) => rank(a) - rank(b)).slice(0, n);
}

/** Fold a production's folder tree away or open it again; a newly folded one goes first, fifty are kept. */
export function toggleFolded(list: readonly string[], id: string): string[] {
  return list.includes(id) ? list.filter((x) => x !== id) : [id, ...list].slice(0, 50);
}

/** The productions whose folder tree is folded away in the sidebar, kept per browser. */
export const loadFolded = (): string[] => parseIds(safeGet(FOLDED_KEY));

export const saveFolded = (list: readonly string[]) => safeSet(FOLDED_KEY, JSON.stringify(list));
